<template>
  <v-app
    style="width: 100%"
    class="pa-3 pt-0"
  >
    <div class="px-3 d-flex">
      <div style="display: flex">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              class="float-left mt-1"
              small
              v-on="on"
            >
              <v-icon
                color="primary"
                style="font-size: 22px"
                @click="print"
              >
                mdi-cloud-print-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('print') }}</span>
        </v-tooltip>
      </div>
      <v-spacer />
      <telegram-button
        :url="'https://abr.abriron.com/print/invoice/' + $route.params.id"
        btn-text=""
        :has-icon="true"
        :description="$t('invoice') + ' - ' + $t(type)"
      />
      <whatsapp-button
        :url="'https://abr.abriron.com/print/invoice/' + $route.params.id"
        btn-text=""
        :has-icon="true"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-clipboard:copy="'https://abr.abriron.com/print/invoice/' + $route.params.id"
            v-bind="attrs"
            class="float-left mt-1 mx-2"
            small
            color="teal"
            outlined
            v-on="on"
            @click="copied"
          >
            https://abr.abriron.com/print/invoice/{{ $route.params.id }}
          </v-btn>
        </template>
        <span>{{ $t('copy-link') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f6']"
            v-bind="attrs"
            icon
            small
            class="float-left mt-1"
            @shortkey="goTo(type)"
            v-on="on"
            @click="goTo(type)"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip
        v-if="entrepot"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f7']"
            v-bind="attrs"
            icon
            :disabled="(entrepot ? false : true)"
            small
            class="float-left mt-1"
            @shortkey="entrepotPrint()"
            v-on="on"
            @click="entrepotPrint()"
          >
            <v-icon
              color="orange"
              style="font-size: 22px"
            >
              mdi-warehouse
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(entrepot.type + 'Print') }} (f7)</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="mt-1"
            v-on="on"
            @click="edit"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-clipboard-edit
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('edit') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="mt-1"
            small
            v-on="on"
            @click="goTo( type + 'List' )"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('list') }} {{ $t(type) }}</span>
      </v-tooltip>
    </div>
    <div
      id="print"
      class="px-3"
    >
      <v-data-table
        v-if="headers"
        ref="table"
        :headers="headers"
        :items="items"
        mobile-breakpoint="0"
        :items-per-page="(numberPrint ? 0 : 8000000000000)"
        hide-default-footer
      >
        <template v-slot:item.unit="{ item }">
          {{ (item.unit ? item.unit.fame : '') }}
        </template>
        <template v-slot:item.product="{ item }">
          <div align="center">
            {{ item.product.name }}
          </div>
        </template>
        <template v-slot:item.count="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.count)) }}
          </div>
        </template>
        <template
          v-slot:item.fee="{ item }"
        >
          <div align="center">
            {{ $numberFormat(parseFloat(item.fee)) }}
          </div>
          <div
            v-if="item.discount && item.discount > 0"
            align="center"
          >
            {{ $numberFormat(parseFloat(item.discount)) }} ( {{ ((parseFloat(item.discount) / parseFloat(item.fee * item.count)) * 100).toFixed(decimal) }} %)
          </div>
          <div
            v-if="item.tax && item.tax > 0"
            align="center"
          >
            {{ $t('tax') }} : {{ $numberFormat(parseFloat(item.tax)) }}
          </div>
        </template>
        <template v-slot:item.row="{ item }">
          <div align="center">
            {{ parseInt(items.indexOf(item))+ parseFloat(1) }}
          </div>
        </template>
        <template v-slot:item.tax="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.tax)) }}
          </div>
        </template>
        <template v-slot:item.discount="{ item }">
          <div
            v-if="item.discount && item.discount > 0"
            align="center"
          >
            {{ $numberFormat(parseFloat(item.discount)) }} ( {{ ((parseFloat(item.discount) / parseFloat(item.fee * item.count)) * 100).toFixed(decimal) }} %)
          </div>
        </template>
        <template v-slot:item.sum="{ item }">
          <div align="center">
            {{ $numberFormat((parseFloat(item.fee * item.count)).toFixed(decimal)) }}
          </div>
        </template>
        <template v-slot:item.finalAmount="{ item }">
          <div align="center">
            {{ $numberFormat((parseFloat(item.fee * item.count) + parseFloat(item.tax) - parseFloat(item.discount)).toFixed(decimal)) }}
          </div>
        </template>
        <template
          v-slot:body.append="{ item }"
        >
          <tr
            style="background-color: aliceblue;"
            class="hide"
          >
            <td
              :colspan="3"
            >
              <strong>{{ $t('sumItem') }}</strong>
            </td>
            <td
              :colspan="2"
            >
              <div align="center">
                {{ $numberFormat(totals.count.toFixed(decimal)) }}
              </div>
            </td>
          </tr>
          <tr
            v-show="item && item.discount && item.discount > 0"
            style="background-color: aliceblue;"
            class="hide"
          >
            <td
              :colspan="`${isMobile?3:3}`"
            >
              <strong>{{ $t('sum') }} {{ $t('discount') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?2:2}`"
            >
              <div
                v-if="totalDiscount && totalDiscount > 0"
                align="center"
              >
                {{ $numberFormat(totalDiscount) }} ({{ ((totalDiscount / totals.fee) * 100).toFixed(decimal) }} %)
              </div>
            </td>
          </tr>
          <tr
            v-show="item && item.tax && item.tax > 0"
            style="background-color: aliceblue;"
            class="hide"
          >
            <td
              :colspan="`${isMobile?3:3}`"
            >
              <strong>{{ $t('sum') }} {{ $t('tax') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?2:2}`"
            >
              <div align="center">
                {{ $numberFormat(totals.tax) }}
              </div>
            </td>
          </tr>
          <tr
            style="background-color: aliceblue;"
            class="hide"
          >
            <td
              :colspan="`${isMobile?3:3}`"
            >
              <strong>{{ $t('paymantable') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?2:2}`"
            >
              <div
                align="center"
                style="font-size: 16px"
              >
                {{ $numberFormat(totals.fee - totalDiscount + totals.tax) }}
              </div>
            </td>
          </tr>
          <tr>
            <td
              :colspan="`${isMobile?5:5}`"
            >
              <div
                v-if="content"
                align="center"
                class="my-2"
              >
                {{ content }}
              </div>
              <div
                v-if="self && self.invoiceContent"
                class="mt-2"
                align="center"
                v-html="self.invoiceContent"
              />
            </td>
          </tr>
          <tr>
            <td
              :colspan="`${isMobile?5:5}`"
              class="pt-1"
            >
              <div
                align="right"
              >
                {{ $t('address') }} : {{ (self && self.address ? self.address : '') }}
              </div>
              <div
                align="right"
              >
                {{ $t('phone') }} : {{ (self && self.phone ? self.phone : '') }}
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="customSizeDialog"
      width="60%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="customSizeDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print-size') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
            <v-text-field
              v-model="width"
              outlined
              dense
              type="number"
              :label="$t('width') + '(cm)'"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
            <v-text-field
              v-model="height"
              outlined
              dense
              type="number"
              :label="$t('height') + '(cm)'"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="setCustomeSize"
              >
                {{ $t('submit') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="customSizeDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
  import store from '../../../../store'
  import General from '../../../../Mixins/general'
  import WhatsappButton from 'vue-share-buttons/src/components/WhatsAppButton'
  import TelegramButton from 'vue-share-buttons/src/components/TelegramButton'
  export default {
    components: {
      TelegramButton,
      WhatsappButton,
    },
    mixins: [General],
    props: ['headerProp', 'itemsProp', 'title', 'idProp', 'backUrl', 'offlineProp', 'abrironPrinterProp', 'numberPrint'],
    data () {
      return {
        headerPrint: [],
        items: [],
        printType: 'unofficial',
        type: null,
        snakbarColor: null,
        snakbarText: null,
        snakbar: null,
        content: null,
        id: null,
        date: null,
        account: null,
        number: null,
        currency_amount: null,
        dueDate: null,
        currency: null,
        tax: null,
        discount: null,
        entrepot: null,
        totalTax: null,
        totalDiscount: null,
        totalCount: null,
        totalFee: null,
        sum: null,
        width: null,
        height: null,
        user: null,
        customer: null,
        currencyName: '',
        self: null,
        headers: null,
        copyClip: null,
        copyClip2: null,
        decimal: 0,
        customSizeDialog: null,
        printSize: '29.7cm 21cm',
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.count += parseFloat(d.count)
          acc.fee += (parseFloat(d.fee) * parseFloat(d.count))
          acc.discount += parseFloat(d.discount)
          acc.tax += parseFloat(d.tax)
          return acc
        }, {
          count: 0,
          fee: 0,
          discount: 0,
          tax: 0,
        })
        totals.fee = totals.fee.toFixed(this.decimal)
        return totals
      },
    },
    watch: {
      printType () {
        // if (this.idProp && this.$refs.table) {
        var header = this.$refs.table.$el.querySelector('.v-data-table-header')
        header.deleteRow(0)
        header.deleteRow(0)
        this.setheader()
      //   this.show()
      // }
      },
      headerProp () {
      // this.head = this.itemsProp
      },
      itemsProp () {
        this.items = this.itemsProp
      },
    },
    beforeMount () {
      var barcode = document.createElement('script')
      barcode.setAttribute('src', 'https://abr.abriron.com/js/JsBarcode.all.min.js')
      document.head.appendChild(barcode)
      this.tableHeader()
      var storage = JSON.parse(localStorage.getItem('token'))
      if (storage != null) {
        store.commit('SET_START_DATE', storage.init.startDate)
        store.commit('SET_END_DATE', storage.init.endDate)
        store.commit('SET_DATE_LOCALE', storage.init.date_locale.value)
        if (storage.init.date_locale.value === 'fa,en') {
          store.commit('SET_DATE_FORMAT', 'jYYYY/jMM/jDD')
        } else {
          store.commit('SET_DATE_FORMAT', 'YYYY/MM/DD')
          store.commit('SET_START_DATE', null)
          store.commit('SET_END_DATE', null)
        }
        store.commit('SET_RTL', storage.init.rtl.value)
        store.commit('SET_DARK', storage.init.dark.value)
        store.commit('SET_LANG', storage.init.lang.value)
        store.commit('SET_THEME_COLOR', storage.init.theme_color.value)
      }
      this.$vuetify.theme.dark = this.$store.state.dark
      this.$root.$i18n.locale = this.$store.state.lang
      this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary = this.$store.state.theme_color
      if (this.$store.state.rtl) {
        this.$vuetify.rtl = true
        storage.init.rtl.value = true
        localStorage.setItem('token', JSON.stringify(storage))
      } else {
        this.$vuetify.rtl = false
      }
      var offlineCheck = this.$route.params.id.includes('@')
      if (this.$route.params.id && !offlineCheck) {
        this.id = this.$route.params.id
        this.show()
      }
      if (this.$route.params.id && offlineCheck) {
        this.id = this.$route.params.id
        this.showOffline()
      }
      if (this.idProp) {
        this.id = this.idProp
        this.show()
      }
    },
    mounted () {
    },
    methods: {
      edit () {
        this.$router.push({ name: this.type + 'Edit', params: { id: this.idProp } })
      },
      entrepotPrint () {
        this.$router.push({ name: this.entrepot.type + 'Print', params: { id: this.entrepot.id } })
      },
      tableHeader () {
        this.headers = [
          {
            text: '#',
            align: 'center',
            sortable: false,
            value: 'row',
          },
          {
            text: this.$t('product') + '/' + this.$t('service'),
            sortable: false,
            value: 'product',
            align: 'center',
          },
          {
            text: this.$t('count'),
            sortable: false,
            value: 'count',
            align: 'center',
          },
          {
            text: this.$t('fee') + '(' + this.currencyName + ')',
            sortable: false,
            value: 'fee',
            class: 'hide',
            cellClass: 'hide',
            align: 'center',
          },
          {
            text: this.$t('finalAmount') + '(' + this.currencyName + ')',
            sortable: false,
            value: 'finalAmount',
            class: 'hide',
            cellClass: 'hide',
            align: 'center',
          },
        ]
      },
      setheader () {
        if (this.$refs.table !== undefined) {
          var elm = this.$refs.table.$el.querySelector('.v-data-table-header')
          var tr1 = document.createElement('tr')
          var tr2 = document.createElement('tr')
          // var tr3 = document.createElement('tr')
          var currDate = new Date()
          if (this.numberPrint) {
            tr1.innerHTML = '' +
              '<th style="padding: 20px;" colspan="5">' +
              '<div style="display: flex">' +
              '<div style="width: 100%">' +
              '<div align="center" style="text-align:center;font-size: 16px !important;color: #000000 !important;"> ' + this.self.abrName + '</div>' +
              '<div style="border:1px solid #000000;height:160px;padding:4px;font-size: 15px !important;color: #000000 !important;" align="right">' +
              '' + (this.numberPrint ? this.$t('id') : this.$t('id')) + ': ' + (this.numberPrint ? this.id : this.id) + ' ' +
              '<img width="100%" class="barcode" height="150px"  jsbarcode-value="' + (this.numberPrint ? this.id : this.id) + '" jsbarcode-textmargin="0"  jsbarcode-fontoptions="bold" >' +
              '</div>' +
              '</th>'
          } else {
            tr1.innerHTML = '' +
              '<th style="padding: 4px" colspan="5">' +
              '<div style="display: flex">' +
              '<div style="width: 33.33%">' +
              '<div style="border:1px solid #000000;height:100px;padding:4px;font-size: 15px !important;color: #000000 !important;" align="right">' +
              '' + (this.numberPrint ? this.$t('id') : this.$t('id')) + ': ' + (this.numberPrint ? this.id : this.id) + ' ' +
              '<img width="100%" class="barcode" height="60px"  jsbarcode-value="' + (this.numberPrint ? this.id : this.id) + '" jsbarcode-textmargin="0"  jsbarcode-fontoptions="bold" >' +
              '</div>' +
              '</div>' +
              '<div style="width: 33.33%">' +
              // '<div  align="center"><img height="70" class="mx-1" src="' + (this.self.logo ? this.self.logo.link : '') + '" width="70"></div>' +
              '<div align="center" style="font-size: 16px !important;color: #000000 !important;"> ' + this.self.abrName + '</div>' +
              // '<div align="center" style="font-size: 12px !important;color: #000000 !important;"> ' + this.self.invoiceSubtitle + '</div>' +
              '</div>' +
              '<div style="width: 33.33% ">' +
              '<div style="border:1px solid #000000;height:40px;;padding: 0px 4px;">' +
              '<div style="font-size: 13px !important;color: #000000 !important;" align="left">' + currDate.getHours() + ':' + currDate.getMinutes() + ' </div>' +
              '<div style="font-size: 13px !important;color: #000000 !important;" align="left">' + this.date + ' </div>' +
              '</div>' +
              '</div>' +
              '</div>' +
              '<div style="width: 100% ">' +
              '<div style="font-size: 13px !important;color: #000000 !important;" align="center">' + this.$t('customer') + ': ' + (this.customer.gender ? this.$t(this.customer.gender) : '') + ' ' + this.customer.name + ' </div>' +
              '<div style="font-size: 12px !important;color: #000000 !important;" align="center">' + this.$t('mobile') + ': ' + (this.customer && this.customer.mobile ? this.customer.mobile : '') + ' </div>' +
              '<div style="font-size: 12px !important;color: #000000 !important;" align="center">' + this.$t('address') + ': ' + (this.customer && this.customer.address ? this.customer.address : '') + ' </div>' +
              '</div>' +
              '</div>' +
              '</th>'
          }
          if (this.printType === 'official') {
            tr2.innerHTML = '' +
              '<th colspan="6" style="padding: 6px 6px">' +
              '<div align="right">' + this.$t('seller') + ': ' + this.self.abrName + ' </div>' +
              '<div align="right">' + this.$t('phone') + ': ' + (this.self.phone ? this.self.phone : '') + ' </div>' +
              '<div align="right">' + this.$t('mobile') + ': ' + (this.self.mobile ? this.self.mobile : '') + ' </div>' +
              '<div align="right">' + this.$t('address') + ': ' + (this.self.address ? this.self.address : '') + ' </div>' +
              '<div align="right">' + this.$t('national-code') + ': ' + (this.self.nationalCode ? this.self.nationalCode : '') + ' </div>' +
              '<div align="right">' + this.$t('financial-code') + ': ' + (this.self.financialCode ? this.self.financialCode : '') + ' </div>' +
              '</th>' +
              '<th colspan="3" style="padding: 6px 6px">' +
              '<div align="right">' + this.$t('buyer') + ': ' + (this.customer.gender ? this.$t(this.customer.gender) : '') + ' ' + this.customer.name + ' </div>' +
              '<div align="right">' + this.$t('phone') + ': ' + (this.customer.phone ? this.customer.phone : '') + ' </div>' +
              '<div align="right">' + this.$t('mobile') + ': ' + (this.customer.mobile ? this.customer.mobile : '') + ' </div>' +
              '<div align="right">' + this.$t('address') + ': ' + (this.customer.address ? this.customer.address : '') + ' </div>' +
              '<div align="right">' + this.$t('national-code') + ': ' + (this.customer.national_code ? this.customer.national_code : '') + ' </div>' +
              '<div align="right">' + this.$t('financial-code') + ': ' + (this.customer.financial_code ? this.customer.financial_code : '') + ' </div>' +
              '</th>'
          } else {
            tr2.innerHTML = '' +
              '<th colspan="9" style="padding: 6px 6px">' +
              '<div align="right" style="font-size: 13px !important;color: #000000 !important;">' + this.$t('buyer') + ': ' + (this.customer.gender ? this.$t(this.customer.gender) : '') + ' ' + this.customer.name + ' </div>' +
              '<div align="right" style="font-size: 13px !important;color: #000000 !important;">' + this.$t('phone') + ': ' + (this.customer.phone ? this.customer.phone : '') + ' </div>' +
              '<div align="right" style="font-size: 13px !important;color: #000000 !important;">' + this.$t('mobile') + ': ' + (this.customer.mobile ? this.customer.mobile : '') + ' </div>' +
              '<div align="right" style="font-size: 13px !important;color: #000000 !important;">' + this.$t('address') + ': ' + (this.customer.address ? this.customer.address : '') + ' </div>' +
              '</th>'
          }

          elm.prepend(tr1)
          window.JsBarcode('.barcode').init()
        }
      },
      showOffline () {
        var app = this
        var list = JSON.parse(localStorage.getItem('invoice'))
        var abr = JSON.parse(localStorage.getItem('abr'))
        var invoice = list.find(inv => inv.ouid === this.id)
        app.currency = invoice.currency
        app.currency_amount = invoice.currency_amount
        app.currencyName = invoice.currency.name
        app.decimal = (invoice.currency ? invoice.currency.decimal : 0)
        app.number = invoice.number
        app.content = invoice.content
        app.date = invoice.date
        app.type = invoice.type
        app.items = invoice.items
        app.account = invoice.account
        app.entrepot = invoice.entrepot
        app.dueDate = invoice.due_date
        app.payments = invoice.payments
        app.checks = invoice.checks
        app.status = invoice.status
        app.discount = invoice.discount
        app.totalDiscount = invoice.totalDiscount
        app.totaltax = invoice.totaltax
        // app.user = invoice.user
        app.customer = invoice.account
        app.self = abr
        app.tableHeader()
        setTimeout(function () {
          app.render = true
          app.setheader()
          app.print()
        }, 1000)
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice/' + this.id + '/edit', {
          params: {
            id: this.idProp,
            print: 'active',
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.id = res.id
              app.currency = res.currency
              app.currency_amount = res.currency_amount
              app.currencyName = res.currency.name
              app.decimal = (res.currency ? res.currency.decimal : 0)
              app.tableHeader()
              app.number = res.number
              app.content = res.content
              app.date = res.date
              app.type = res.type
              app.items = res.article
              app.account = res.customer
              app.entrepot = res.entrepot
              app.dueDate = res.due_date
              app.payments = res.payments
              app.checks = res.checks
              app.status = (res.last_status ? res.last_status.status : null)
              app.discount = res.discount
              app.totalDiscount = res.discount
              app.totaltax = res.tax
              app.user = res.user
              app.customer = res.customer
              app.self = res.self
              this.setheader()
              setTimeout(function () {
                app.render = true
                app.print()
              }, 1000)
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearCustom () {
        this.height = null
        this.width = null
      },
      setCustomeSize () {
        this.printSize = this.width + 'cm ' + this.height + 'cm'
        this.customSizeDialog = false
      },
      print () {
        var direction = 'ltr'
        if (this.$vuetify.rtl) {
          direction = 'rtl'
        }
        var app = this
        var style = '<style>' +
          '.v-data-table__wrapper {overflow-x: inherit !important;overflow-y: inherit !important;}' +
          'body { font-size: 12px !important;color: #000000 !important; }' +
          '.v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {font-size: 10px !important;}' +
          'td:not(.stiJsViewerClearAllStyles) {font-size: 13px !important;color: #000000 !important;}' +
          'table { border: none; border-collapse: collapse; }' +
          'table td { border: 1px solid #000000; }' +
          'table th { border: 1px solid #000000;font-size: 13px !important;color: #000000 !important; }' +
          'tbody > tr > td {border: 1px solid #000000 !important;}' +
          'thead > tr > th { border: 1px solid #000000 !important; }' +
          '@bottom-left {content: normal;margin: 3px;}' +
          '</style>'
        setTimeout(async function () {
          // Get HTML to print from element
          const prtHtml = document.getElementById('print').innerHTML
          const prtHead = document.getElementsByTagName('tr')[0]
          var data
          if (app.numberPrint) {
            data = {
              type: 'print',
              body: '<table><thead>' + prtHead.innerHTML + '</thead></table>',
            }
          } else {
            data = {
              type: 'print',
              body: prtHtml,
            }
          }
          if (app.abrironPrinterProp) {
            const clipText = await navigator.clipboard.writeText(JSON.stringify(data))
            app.copyClip = clipText
            setTimeout(async function () {
              const clipText2 = await navigator.clipboard.writeText(0)
              app.copyClip2 = clipText2
            }, 10)
          } else {
            let stylesHtml = ''
            let node = null
            for (node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
              stylesHtml += node.outerHTML
            }
            const WinPrint = window.open('', '', 'left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0')
            WinPrint.document.write('<!DOCTYPE html> <html> <head> ' + stylesHtml + ' ' + style + ' </head> <body style="direction: ' + direction + '">' + prtHtml + ' </body> </html>')
            WinPrint.document.close()
            WinPrint.focus()
            setTimeout(function () {
              WinPrint.print()
              WinPrint.close()
            }, 2000)
          }
          if (app.backUrl) {
            app.$store.commit('REMOVE_COMPONENTS', app.$route)
            app.goTo(app.backUrl)
          }
        }, 50)
      },
      copied () {
        this.snakbarText = this.$t('copied')
        this.snakbarColor = 'blue'
        this.snakbar = true
      },
    },
  }
</script>

<style scoped>
.share-button {
  width: 28px;
  height: 28px;
  min-width: 0px !important;
  min-height: 0px !important;
  padding: 0px 0px !important;
}
</style>
